import React, { forwardRef } from "react";
import styles from "./buttonNextGame.module.css";

const ButtonNextGame = forwardRef((props, ref) => {
  return (
    <div className={styles.body}>
      <button ref={ref} className={styles.button1} onClick={props.onClick}>
        <div>{props.children}</div>
      </button>
    </div>
  );
});

export default ButtonNextGame;
